import React, { useEffect, useState } from "react";
import "./TalentSourcing.scss";
import Detect from "../Detect/Detect";
import Filter from "../Filter/Filter";
import Result from "../Result/Result";
import { Empty, Steps } from "antd";
import Pipeline from "@components/Pipeline/Pipeline";
import PhaseSlider from "@components/PhaseSlider/PhaseSlider";
import businessLogicApi from "services/BusinessLogicApi";
import Helpers from "@utils/Helpers";
import { ICampaign } from "@utils/Interfaces";
import { useTour } from "@reactour/tour";
import { DetectSteps } from "@components/GuidedTour/steps/DetectSteps";
import { FilterSteps } from "@components/GuidedTour/steps/FilterSteps";
import { ResultSteps } from "@components/GuidedTour/steps/ResultSteps";
const steps = [
  {
    title: "Detect",
    description: "industries & positions.",
  },
  {
    title: "Filter",
    description: "item which is detected.",
  },
  {
    title: "Result",
    description: "Result & Evaluation.",
  },
];

const TalentSourcing: React.FC = () => {
  const { setSteps, setIsOpen, setCurrentStep } = useTour();
  const [campaignCurrentStep, setCampaignCurrentStep] = useState(0);
  const [campaign, setCampaign] = useState<ICampaign>();
  const [isFetch, setIsFetch] = useState(false);
  const [industriesKeyword, setIndustriesKeyword] = useState<string[]>([]);
  const [positionsKeyword, setPositionsKeyWord] = useState<string[]>([]);
  const [pusherEventCraw, setPusherEventCrawl] = useState("");
  const [pusherChannelCrawl, setPusherChannelCrawl] = useState("");
  const [aboutCompany, setAboutCompany] = useState("");
  const [jobDescription, setJobDescription] = useState("");

  const urlParams = new URLSearchParams(window.location.search);
  const campaignId = urlParams.get("id");
  const notification = Helpers.notification;
  const tour = localStorage.getItem("tour");

  // FETCH CAMPAIGN
  useEffect(() => {
    const fetchCampaign = async () => {
      try {
        const response = await businessLogicApi.GetCampaign(
          parseInt(campaignId!)
        );
        if (response.status == 200) {
          setCampaign(response.data.campaign);
          setCampaignCurrentStep(response.data.campaign.step - 1);
          setIsFetch(true);
        }
      } catch (error) {
        notification.error("Something wrong in server. Please try agian");
      }
    };
    if (!isFetch) {
      fetchCampaign();
    }
  }, [isFetch, campaignId]);

  // ASSIGN VALUE FROM CAMPAIGN TO FIELDS
  useEffect(() => {
    if (campaign != undefined && Object.keys(campaign).length > 0) {
      setAboutCompany(campaign?.about_company || "");
      setJobDescription(campaign?.job_description || "");
      setIndustriesKeyword(campaign.domain_keywords || []);
      setPositionsKeyWord(campaign.position_keywords || []);
    }
  }, [campaign]);

  // SET STEP LIST FOR GUIDED TOUR
  useEffect(() => {
    var step: any = null;
    switch (campaignCurrentStep) {
      case 0:
        step = DetectSteps;
        break;
      case 1:
        step = FilterSteps;
        break;
      default:
        step = ResultSteps;
        break;
    }
    setSteps?.(step);
    setCurrentStep(0);
    setTimeout(() => {
      if (tour) {
        setIsOpen(true);
        localStorage.removeItem("tour");
      }
    }, 1000);
  }, [campaignCurrentStep]);

  return (
    <>
      <div className="TalentSourcing">
        <div className="card header">
          <div
            className="card-header d-flex align-items-center"
            id="card-talent"
          >
            <div className="group-header">
              <div className="title-group">
                <div className="page-title">{campaign?.campaign_name}</div>
                <div className="page-subtitle">
                  Please enter complete information to benefit employers in
                  finding potential candidates
                </div>
              </div>
            </div>
          </div>
        </div>
        <PhaseSlider tasks={campaign?.phases} />
        <Pipeline activePhase={campaign?.phase!} phases={campaign?.phases} />
        <div className="card" id="talent-sourcing-body">
          <div className="container px-5">
            <Steps
              size="small"
              className="Heppai-step"
              current={campaignCurrentStep}
              items={steps}
            />
          </div>
          {!isFetch ? (
            <div className="h-100 mt-5">
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            </div>
          ) : (
            <div id="multi-step-form" className="step-group h-100">
              <div className="step step-1 step-input">
                <Detect
                  campaign={campaign!}
                  visible={campaignCurrentStep === 0}
                  campaignCurrentStep={campaignCurrentStep}
                  setCampaignCurrentStep={setCampaignCurrentStep}
                  industriesKeyword={industriesKeyword}
                  setIndustriesKeyword={setIndustriesKeyword}
                  positionsKeyword={positionsKeyword}
                  setPositionsKeyword={setPositionsKeyWord}
                  aboutCompany={aboutCompany}
                  setAboutCompany={setAboutCompany}
                  jobDescription={jobDescription}
                  setJobDescription={setJobDescription}
                />
              </div>
              <div className="step step-2 step-input">
                <Filter
                  campaign={campaign!}
                  visible={campaignCurrentStep === 1}
                  campaignCurrentStep={campaignCurrentStep}
                  setCampaignCurrentStep={setCampaignCurrentStep}
                  industriesKeyword={industriesKeyword}
                  setIndustriesKeyword={setIndustriesKeyword}
                  positionsKeyword={positionsKeyword}
                  setPositionsKeyWord={setPositionsKeyWord}
                  setPusherChannelCrawl={setPusherChannelCrawl}
                  setPusherEventCrawl={setPusherEventCrawl}
                />
              </div>
              <div className="step step-3 step-input">
                <Result
                  campaign={campaign!}
                  campaignCurrentStep={campaignCurrentStep}
                  pusherChannelCrawl={pusherChannelCrawl}
                  pusherEventCrawl={pusherEventCraw}
                  visible={campaignCurrentStep === 2}
                  jobDescription={jobDescription}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default TalentSourcing;
